import { render } from "./stellar.vue?vue&type=template&id=158b5d75&ts=true"
import script from "./stellar.vue?vue&type=script&lang=ts"
export * from "./stellar.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/stellar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "158b5d75"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('158b5d75', __exports__)) {
    api.reload('158b5d75', __exports__)
  }
  
  module.hot.accept("./stellar.vue?vue&type=template&id=158b5d75&ts=true", () => {
    api.rerender('158b5d75', render)
  })

}


export default __exports__